

export const homes1 = [
    {image: '/Home1/pic1.jpg'},
    {image: '/Home1/pic2.jpg'},
    {image: '/Home1/pic3.jpg'},
    {image: '/Home1/pic4.jpg'},
    {image: '/Home1/pic5.jpg'},
]

export const homes2 = [
    {image: '/Home2/pic1.jpg'},
    {image: '/Home2/pic2.jpg'},
    {image: '/Home2/pic3.jpg'},
    {image: '/Home2/pic4.jpg'},
    {image: '/Home2/pic5.jpg'},
]

export const homes3= [
    {image: '/Home3/pic1.jpg'},
    {image: '/Home3/pic2.jpg'},
    {image: '/Home3/pic3.jpg'},
    {image: '/Home3/pic4.jpg'},
    {image: '/Home3/pic5.jpg'},
]

export const aboutPageBackground = 
    {image: '/assets/Krumlov.jpg'}
